import { unByKey } from 'ol/Observable';
import { Country, State, District, Municipality, SoloMunicipality } from './components';
import { isDrawingWithPolygonTool } from '../tools/bat'; 

export class MapNavigator
{
    constructor(map)
    {
        this.map = map;
        this.mapEventKeys = [];

        this.soloMunicipality = new SoloMunicipality();
        this.municipality = new Municipality({ innerComponent: this.soloMunicipality });
        this.district = new District({ innerComponent: this.municipality });
        this.state = new State({ innerComponent: this.district });
        this.country = new Country({ innerComponent: this.state });

        this.state.addTo(this.map, {recursive:true});
    }

    turnOnInteraction()
    {
        this._addOnClickNavigation();
        this._addHoverInteraction();
    }

    getLayerFilter()
    {
        return layer => [this.state.layer, this.district.layer, this.municipality.layer].includes(layer);
    }

    _addOnClickNavigation()
    {
        const clickEventKey = this.map.on('singleclick', event =>
        {
            this.map.forEachFeatureAtPixel( event.pixel, async (feature, layer) =>
            {
                if (isDrawingWithPolygonTool()) return false;
                if (layer===this.state.layer) await this.state.select( feature.get(this.state.codeField) );
                if (layer===this.district.layer)  await this.district.select( feature.get(this.district.codeField) );
                if (layer===this.municipality.layer)
                {
                    await this.municipality.select( feature.get(this.municipality.codeField) );
                }
            }, { layerFilter : this.getLayerFilter() } );
        });
        this.mapEventKeys.push(clickEventKey);
    }

    _addHoverInteraction()
    {
        const map = this.map;
        const layerFilter = this.getLayerFilter();
        const hoverKey = map.on('pointermove', function (event)
        {
            const hit = this.hasFeatureAtPixel(event.pixel, {layerFilter})
            this.getTargetElement().style.cursor = hit ? 'pointer' : '';
        });
        this.mapEventKeys.push(hoverKey);
    }

    async reselectLastRegion()
    {
        const component = this.country.getInnermostSelectedComponent();
        component.select(component.currentCode, {reselect:true});
    }

    async selectMunicipalityFromTop(sddmm)
    {
        const scode = parseInt(sddmm.toString()[0]);
        const dcode = parseInt(sddmm.toString().slice(1,3));
        await this.state.select(scode);
        await this.district.select(dcode);
        await this.municipality.select(parseInt(sddmm), {reselect: true})
    }

    destroy()
    {
        const layers = [this.state.layer, this.district.layer, this.municipality.layer, this.soloMunicipality.layer];
        layers.forEach( layer => this.map.removeLayer(layer) );
        unByKey(this.mapEventKeys);
    }
}

let navigator = null;

export const getNavigator = () => navigator;

export const getNavigatorAsync = (count=0) =>
{
    return new Promise((resolve, reject) => 
    {
        if (count > 10)
        {
            reject("getNavigatorAsync is taking too damn long")
        }
        getNavigator() ?
            resolve(getNavigator())
            :
            setTimeout(() => resolve(getNavigatorAsync(count+1)), 500);
    });
}

export const selectMunicipalityFromTop = async (sddmm) =>
{
    await getNavigatorAsync().then(navigator => navigator.selectMunicipalityFromTop(sddmm));
}
export const initNavigator = map =>
{
    navigator = new MapNavigator(map)
    navigator.turnOnInteraction();
    return navigator;
};
